<template>
    <b-modal
      ref="modal-monitoring-new-employee"
      :title="$t('New Employee')"
      modal-class="modal-primary"
      @hidden="$emit('hideModal')"
      size="lg"
      no-close-on-backdrop
    >
      <validation-observer ref="form-settings-homework-status">
        <div>
          <b-row class="border-right">
            <!-- Abrevisions -->
            <b-col cols="6">
              <b-form-group>
                <div class="d-flex justify-content-between text-white">
                  <label for="check-destination" v-t="'First Name'"></label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="abrevision"
                  rules="required"
                >
                  <b-input-group>
                    <b-form-input
                      :class="{ 'border-danger rounded': errors[0] }"
                      v-model="employee.first_name"
                      type="text"
                    ></b-form-input>
                  </b-input-group>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="6">
              <b-form-group>
                <div class="d-flex justify-content-between text-white">
                  <label for="check-reason" v-t="'Last Name'"></label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="viatic_status"
                  rules="required"
                >
                  <b-input-group>
                    <b-form-input
                      :class="{ 'border-danger rounded': errors[0] }"
                      v-model="employee.last_name"
                      type="text"
                    ></b-form-input>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="5">
              <b-form-group>
                <div class="d-flex justify-content-between text-white">
                  <label for="check-destination" v-t="'Document Type'"></label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="abrevision"
                  rules="required"
                >
                  <v-select
                    :class="{ 'border-danger rounded': errors[0] }"
                    v-model="employee.document_type"
                    :options="documentType"
                    :reduce="(val) => val.id"
                    label="label"
                    class="w-100"
                    hint="Select a role"
                  >
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="3">
              <b-form-group>
                <div class="d-flex justify-content-between text-white">
                  <label for="check-reason" v-t="'Document Number'"></label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="viatic_status"
                  rules="required"
                >
                  <b-input-group>
                    <b-form-input
                      :class="{ 'border-danger rounded': errors[0] }"
                      v-model="employee.document_number"
                      type="text"
                    ></b-form-input>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="4">
              <b-form-group>
                <div class="d-flex justify-content-between text-white">
                  <label for="check-destination" v-t="'Area'"></label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="abrevision"
                  rules="required"
                >
                  <v-select
                    small
                    :class="{ 'border-danger rounded': errors[0] }"
                    v-model="employee.area"
                    :options="personalType"
                    :reduce="(val) => val.id"
                    label="label"
                    class="w-100"
                    hint="Select a role"
                  ></v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="3">
              <b-form-group>
                <div class="d-flex justify-content-between text-white">
                  <label for="check-destination" v-t="'Personal Type'"></label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="abrevision"
                  rules="required"
                >
                  <v-select
                    small
                    :class="{ 'border-danger rounded': errors[0] }"
                    v-model="employee.personal_type"
                    :options="personalType"
                    :reduce="(val) => val.id"
                    label="label"
                    class="w-100"
                    hint="Select a role"
                  ></v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="3">
              <b-form-group>
                <div class="d-flex justify-content-between text-white">
                  <label
                    for="check-destination"
                    v-t="'License Category'"
                  ></label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="abrevision"
                  rules="required"
                >
                  <v-select
                    :class="{ 'border-danger rounded': errors[0] }"
                    v-model="employee.license_category"
                    :options="licenseCategories"
                    :reduce="(val) => val.id"
                    label="label"
                    class="w-100"
                    hint="Select a role"
                  >
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="3">
              <b-form-group>
                <div class="d-flex justify-content-between text-white">
                  <label for="check-destination" v-t="'License Number'"></label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="abrevision"
                  rules="required"
                >
                  <b-input-group>
                    <b-form-input
                      :class="{ 'border-danger rounded': errors[0] }"
                      v-model="employee.license_number"
                      type="text"
                    ></b-form-input>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="3">
              <b-form-group>
                <div class="d-flex justify-content-between text-white">
                  <label for="check-destination" v-t="'Gender'"></label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="abrevision"
                  rules="required"
                >
                  <v-select
                    small
                    :class="{ 'border-danger rounded': errors[0] }"
                    v-model="employee.gender"
                    :options="genderType"
                    :reduce="(val) => val.id"
                    label="label"
                    class="w-100"
                    hint="Select a role"
                  >
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="6">
              <b-form-group>
                <div class="d-flex justify-content-between text-white">
                  <label for="check-destination"> {{ $t('entity group') | capitalize }} </label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="abrevision"
                  rules="required"
                >
                  <v-select
                    :class="{ 'border-danger rounded': errors[0] }"
                    v-model="employee.license_category"
                    :options="licenseCategories"
                    :reduce="(val) => val.id"
                    label="label"
                    class="w-100"
                    hint="Select a role"
                  >
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="6">
              <b-form-group>
                <div class="d-flex justify-content-between text-white">
                  <label for="check-destination" v-t="'BIRTHDATE'"></label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="viatic_status"
                  rules="required"
                >
                  <b-form-group>
                    <kendo-datepicker
                      class="form-control w-100 kk-picker-wrap w-100"
                      v-model="employee.birthdate"
                      :format="'MM/dd/yyyy'"
                    ></kendo-datepicker>
                  </b-form-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </validation-observer>
      <!-- Modal footer -->
      <template #modal-footer>
        <b-container fluid>
          <b-row>
            <b-col class="d-flex align-items-center justify-content-end p-0">
              <b-button class="mr-1" @click="hideModal(false, 0)">
                Cancel
              </b-button>
              <b-button variant="primary" @click="onSubmit">
                {{ dataType.type == "create" ? "Save" : "Update" }}
              </b-button>
            </b-col>
          </b-row>
          <!-- <pulse-loader :loading="loading" :color="color" :size="size"></pulse-loader> -->
        </b-container>
      </template>
    </b-modal>
</template>
  
  <script>
import { mapGetters } from "vuex";
import HomeworkStatusService from "@/views/settings/views/homework-status/service/homework-status.service";
import VueSelect from "@/views/forms/form-element/vue-select/VueSelect.vue";

// import  DotLoader from 'vue-spinner/src/DotLoader.vue'
export default {
  components: {},
  data() {
    return {
      employee: {
        first_name: null,
        last_name: null,
        personal_type: null,
        cell_phone: null,
        license_category: null,
        license_number: null,
        gender: null,
        document_type: null,
        document_number: null,
        area: null,
        entity_group: null,
        birthdate: null,
      },

      personalType: [
        { id: 1, label: "Employee" },
        { id: 2, label: "Driver" },
        { id: 3, label: "Third Party" },
      ],
      documentType: [
        { id: 1, label: "DNI" },
        { id: 2, label: "RUC" },
        { id: 3, label: "CARNET DE EXTRANJERIA" },
        { id: 4, label: "CEDULA DE IDENTIDAD" },
      ],
      genderType: [
        { id: 1, label: "Female" },
        { id: 2, label: "Male" },
      ],
      licenseCategories: [
        { id: 1, label: "A-I" },
        { id: 2, label: "A-IIA" },
        { id: 3, label: "A-IIB" },
        { id: 4, label: "A-IIIA" },
        { id: 5, label: "A-IIIB" },
        { id: 6, label: "A-IIIC" },
        { id: 7, label: "B-I" },
        { id: 8, label: "B-IIA" },
        { id: 9, label: "B-IIB" },
        { id: 10, label: "B-IIC" },
      ],
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  created() {
    if (this.dataType.type == "edit") {
      (this.newHomeworkStatus.abbreviation = this.dataType.data.abbreviation),
        (this.newHomeworkStatus.description = this.dataType.data.description),
        (this.newHomeworkStatus.viatic_status =
          this.dataType.data.viatic_status),
        (this.newHomeworkStatus.status = this.dataType.data.status),
        (this.newHomeworkStatus.viatic_cost = this.dataType.data.viatic_cost);
    }
  },
  methods: {
    async onSubmit() {
      try {
        const isValidate = await this.$refs[
          "form-settings-homework-status"
        ].validate();
        if (isValidate) {
          let params = {
            status: 1, // Active
            abbreviation: this.newHomeworkStatus.abbreviation,
            description: this.newHomeworkStatus.description,
            viatic_cost:
              this.newHomeworkStatus.viatic_status == 1
                ? this.newHomeworkStatus.viatic_cost
                : null,
            viatic_status: this.newHomeworkStatus.viatic_status,
            created_by: this.currentUser.id,
          };
          await this.addPreloader();
          if (this.dataType.type == "create") {
            await HomeworkStatusService.setHomeworkStatus(params);
          } else {
            params = { ...params, id: this.dataType.data.id };
            await HomeworkStatusService.updateHomeworkStatus(params);
            this.$emit("refresh");
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.$emit("hideModal");
        await this.removePreloader();
      }
    },
  },
  mounted() {
    this.toggleModal("modal-monitoring-new-employee");
  },
};
</script>
  
  <style></style>
  